<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-rectangle-list"></i>
        WMDS(Web Malware distribution Detection System) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Dashboard</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
        <!-- <template slot="header">
          <i class='fa fa-align-justify'></i> WMDS(웹 악성코드 유포 탐지 시스템) Dashboard
        </template> -->
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="site_check_1" :value="info && info.module && info.module.alive && info.module.alive > 0 ? info.module.alive : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> 활성화(현재)</sup></strong></h1>
                <hr>
                <h4>삭제 :
                  <animated-number ref="site_check_2" :value="info && info.module && info.module.deleted && info.module.deleted > 0 ? info.module.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>전체 :
                  <animated-number ref="site_check_4" :value="info && info.module && info.module.deleted > 0 ? info.module.alive + info.module.deleted : (info.module.alive ? info.module.alive : 0)" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <hr>
                <small class="float-right mb-1">
                  가입시점부터
                </small>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="page_check_1" :value="info && info.day && info.day.page_count > 0 ? info.day.page_count : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> 페이지(오늘)</sup></strong></h1>
                  <hr>
                  <trend
                    :data="chart.page"
                    :gradient="['#fff', '#fff', '#5c7']"
                    auto-draw
                    smooth
                    stroke-linecap="round"
                    auto-draw
                    auto-draw-easing
                    :stroke-width="7"
                  >
                  </trend>
                  <hr>
                  <small class="float-right mb-1">
                    최근 1주일 동향
                  </small>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="detect_check_1" :value="info && info.day && info.day.detect_count > 0 ? info.day.detect_count : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> 탐지(오늘)</sup></strong></h1>
                <hr>
                <trend
                  :data="chart.detect"
                  :gradient="['#fff', '#fff', '#f77']"
                  auto-draw
                  smooth
                  stroke-linecap="round"
                  auto-draw
                  auto-draw-easing
                  :stroke-width="7"
                >
                </trend>
                <hr>
                <small class="float-right mb-1">
                  최근 1주일 동향
                </small>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-warning">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="error_check_1" :value="info && info.day && info.day.error_count > 0 ? info.day.error_count : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> 에러(오늘)</sup></strong></h1>
                <hr>
                <trend
                  :data="chart.error"
                  :gradient="['#fff', '#fff', '#fc0']"
                  auto-draw
                  smooth
                  stroke-linecap="round"
                  auto-draw
                  auto-draw-easing
                  :stroke-width="7"
                >
                </trend>
                <hr>
                <small class="float-right mb-1">
                  최근 1주일 동향
                </small>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <vcl-facebook v-if="loading"></vcl-facebook>
      <b-card v-else>
        <span class="title">
          최근 패턴
        </span>
        <hr>
        <b-row>
          <b-col v-if="pattern && pattern.code">
            <b-row>
              <b-col sm="2">
                {{pattern.created_at | sdate}}
              </b-col>
              <b-col sm="1">
                {{codes.WMDS_TYPE[pattern.type]}}
              </b-col>
              <b-col sm="2">
                {{codes.WMDS_LEVEL[pattern.level]}}
              </b-col>
              <b-col>
                {{pattern.code | truncate(70) }}
              </b-col>
            </b-row>
          </b-col>
          <b-col v-else>
            최근 업데이트 된 패턴이 없습니다
          </b-col>
        </b-row>
      </b-card>
      <vcl-facebook v-if="loading"></vcl-facebook>
      <WMDSSiteList v-else :view_only="true" :show_title="true"/>
    <router-view ></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
